<template>
  <transition name="slide-fade">
    <div class="draw" v-show="isShow" @click.self="leavingDraw()">
      <div class="draw-body" :style="drawBodyStyle">
        <transition name="slide-list">
          <span
            class="draw-vip"
            v-if="
              autoDraw.autodata.length &&
              autoDraw.autoAction &&
              drawStatus === 'draw' &&
              !this.UserEquity.autoDraw
            "
          ></span>
        </transition>

        <div class="draw-suggest" :style="{ width: TOOL.clientWidth + 'px' }">
          <transition name="slide-liston">
            <div v-show="!autoDraw.autoAction && drawStatus === 'draw'">
              <div class="open-auto-draw" @click="autoDraw.autoAction = true">
                <span class="el-icon-caret-top"></span>
                图形自动识别
              </div>
            </div>
          </transition>

          <transition name="slide-list">
            <div
              v-show="
                autoDraw.autodata.length &&
                autoDraw.autoAction &&
                drawStatus === 'draw'
              "
            >
              <el-tooltip
                effect="dark"
                content="关闭智能推荐"
                placement="left"
                :open-delay="1000"
              >
                <div
                  class="auto-draw-btn el-icon-caret-bottom"
                  @click="autoDraw.autoAction = false"
                ></div>
              </el-tooltip>

              <div
                class="auto-draw-btn el-icon-arrow-left"
                @click="autoSlide('next')"
              ></div>

              <div
                class="auto-draw-box"
                :style="{ width: Tool_Size.width - 150 + 'px' }"
              >
                <ul
                  class="auto-draw-list"
                  :style="{ left: autoDraw.listLeft + 'px' }"
                >
                  <li
                    class="auto-draw-svg"
                    v-for="unitsvg in autoDraw.autodata"
                  >
                    <div @click="addAutoSvg(unitsvg.svg)">
                      <img :src="$handleAssetsUrl(unitsvg.thumb)" />
                    </div>
                  </li>
                </ul>
              </div>

              <div
                class="auto-draw-btn el-icon-arrow-right"
                @click="autoSlide('prever')"
              ></div>
            </div>
          </transition>
        </div>

        <div
          v-show="!showPathSet"
          class="btn-content"
          :style="{ width: TOOL.clientWidth + 'px' }"
        >
          <div class="left-box">
            <el-tooltip
              effect="dark"
              content="配色"
              placement="bottom"
              :open-delay="1000"
            >
              <div
                v-show="drawStatus === 'auto'"
                class="path-set-btn left-btn"
                @click="openSet()"
              >
                <i class="icon-draw-match"></i>
                配色
              </div>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              content="颜色"
              placement="bottom"
              :open-delay="1000"
            >
              <div class="left-btn">
                <span
                  v-analysis="BaiduAnalysis['autodraw6']"
                  :style="{ background: penColor }"
                  @click="showColorPicker({ whichPart: 'penColor' })"
                ></span>
              </div>
            </el-tooltip>
            <div class="dragfix">
              <el-slider
                v-model="penWidth"
                :min="2"
                :max="50"
                :show-tooltip="true"
                @change="changePenW"
                @input="inputPenW"
              ></el-slider>
            </div>
            <el-tooltip
              effect="dark"
              content="撤销"
              placement="bottom"
              :open-delay="1000"
            >
              <div
                :class="{ 'left-btn': true, disabled: !canUndo }"
                @click="canUndo && undo()"
              >
                <i
                  :class="{ 'icon-editor-undo': true, disabled: !canUndo }"
                ></i>
              </div>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              content="返回"
              placement="bottom"
              :open-delay="1000"
            >
              <div
                :class="{ 'left-btn': true, disabled: !canRedo }"
                @click="canRedo && redo()"
              >
                <i
                  :class="{ 'icon-editor-redo': true, disabled: !canRedo }"
                ></i>
              </div>
            </el-tooltip>
          </div>
          <div class="right-box">
            <el-tooltip
              effect="dark"
              content="保存当前绘画作品"
              placement="bottom"
              :open-delay="1000"
            >
              <div
                v-analysis="BaiduAnalysis['autodraw1']"
                @click="drawComplete()"
              >
                完成绘画
              </div>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              content="重新绘制图形"
              placement="bottom"
              :open-delay="1000"
            >
              <div
                v-analysis="BaiduAnalysis['autodraw2']"
                @click="backToDraw(true)"
                v-show="drawStatus === 'auto'"
              >
                重画
              </div>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              content="退出后将不保留当前绘画作品"
              placement="bottom"
              :open-delay="1000"
            >
              <div
                v-analysis="BaiduAnalysis['autodraw3']"
                @click="closedrawFs()"
              >
                退出绘画
              </div>
            </el-tooltip>
          </div>
        </div>

        <div
          class="drawing"
          :style="{
            width: TOOL.clientWidth + 'px',
            height: TOOL.clientHeight + 'px',
          }"
        >
          <div
            id="drawing"
            v-show="drawStatus === 'draw'"
            @mousedown="clearTimeAuto()"
            @mouseup="autodrawdata(2000)"
          ></div>
          <div id="autodraw" v-show="drawStatus === 'auto'"></div>
          <div id="drawSprite" style="opcity: 0"></div>
        </div>
        <!-- svg配色弹窗 -->
        <div
          v-show="showPathSet"
          class="color-setting"
          :style="{ top: setDrag.top + 'px', left: setDrag.left + 'px' }"
        >
          <div class="color-setting-title" v-dragWhole>AI作图配色</div>
          <div class="color-setting-fill">
            <span>填充</span>
            <div
              :style="{
                backgroundColor: everyColor === 'none' ? '#fff' : everyColor,
              }"
              @click="showColorPicker({ whichPart: 'fill' })"
            ></div>
          </div>
          <div class="color-setting-stroke">
            <span>描边</span>
            <div
              :style="{
                backgroundColor: strokeColor === 'none' ? '#fff' : strokeColor,
              }"
              @click="showColorPicker({ whichPart: 'stroke' })"
            ></div>
            <p class="stroke-set-slider">
              <el-slider
                v-model="strokeWidth"
                :min="2"
                :max="50"
                @input="inputStrokeW"
                :show-tooltip="true"
              ></el-slider>
            </p>
          </div>
          <div class="color-setting-select">选中要填色的区域</div>
          <div class="path-content" v-bar>
            <div>
              <div class="bar-content">
                <div
                  :class="{ active: i === index }"
                  v-for="(info, i) in pathInfo"
                  @click="
                    changePath(info, i);
                    showColorPicker({ whichPart: 'fill' });
                  "
                  :style="{
                    backgroundColor: info.fill === 'none' ? '#fff' : info.fill,
                  }"
                ></div>
              </div>
            </div>
          </div>
          <div class="color-setting-footer">
            <div @click="certain(true)">确认</div>
            <div @click="certain(false)">不修改</div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
//  弹窗组件，所欲设置的弹窗组件
import { mapGetters } from "vuex";
import Analysis from "./mixins/analysis/materialBu";
import Undo from "../undo/undo.js";

export default {
  mixins: [Analysis],
  data() {
    return {
      isShow: false, // 是否进入绘画模式
      drawpath: null, // 绘画对象
      shapes: [], // 绘画路径的数组
      shapesIndex: 0, // 当前绘画路径的添加位置
      penWidth: 2, // 画笔宽度
      penColor: "#000000", // 画笔颜色
      autoDraw: {
        autodata: [], // 获取的数据
        autoAction: true, // 开始autoAction状态
        listLeft: 0, // left的左右移动
      },
      drawStatus: "draw", // 绘画的阶段
      timeAuto: null, // 防止多次获取auto数据
      svgTitle: "", // svg名字
      showPathSet: false, // 是否显示path设置
      pathList: [], // 解析后的path数组
      pathInfo: [], // path对应的属性
      pathInfoC: [], // path对应的属性备用
      index: -1, // 当前选中的path
      strokeWidth: 2, // 选中path的线宽
      strokeColor: "none", // 选中path的线色
      everyColor: "none", // 选中path的填充色
      rectDom: null, // 选中path的提示框矩形
      setDrag: {
        // 选中path的提示框属性
        top: 0,
        left: 0,
        x: 0,
        y: 0,
        move: false,
      },
      stack: null, // 撤销栈对象
      editCommand: null, // 撤销操作构造函数
      canUndo: false,
      canRedo: false,
    };
  },
  computed: {
    ...mapGetters(["Tool_Size", "TOOL", "MaterialPane_Size", "UserEquity"]),
    drawBodyStyle() {
      const style = {};
      style.width = this.Tool_Size.width + "px";
      style.height = this.MaterialPane_Size.height + "px";
      style.left = this.MaterialPane_Size.width + "px";
      style.borderTop =
        (this.MaterialPane_Size.height - this.TOOL.clientHeight) / 2 +
        "px solid #eff1f8";
      style.borderBottom =
        (this.MaterialPane_Size.height - this.TOOL.clientHeight) / 2 +
        "px solid #eff1f8";
      style.borderRight =
        (this.Tool_Size.width - this.TOOL.clientWidth) / 2 + "px solid #eff1f8";
      style.borderLeft =
        (this.Tool_Size.width - this.TOOL.clientWidth) / 2 + "px solid #eff1f8";
      return style;
    },
  },
  mounted() {
    this.$bus.on("drawing_vue", (data) => {
      if (data.type === "draw") {
        this.isShow = true;
        this.$store.commit("toggle_isPreventDefault", false);
        // 初始化
        $("#drawSprite").empty();
        this.drawStatus = "draw";
        this.autoDraw.autodata = [];
        this.autoDraw.autoAction = true;
        this.penWidth = 2;
        this.penColor = "#000000";
        this.shapes.length = 0;
        this.shapesIndex = 0;

        this.$nextTick(() => {
          this.initPainCanvas();
        });
      }
    });
    this.$bus.on("colorPickerInput.draw", this.colorPickerInput);
    this.$bus.on("draw_close_vue", (data) => {
      // 关闭autodraw
      if (data.type) {
        this.drawComplete();
      }
      this.closedraw();
    });

    // This is custom extension of line, polyline, polygon which doesn't draw the circle on the line.
    SVG.Element.prototype.draw.extend("line polyline polygon", {
      init: function (e) {
        // When we draw a polygon, we immediately need 2 points.
        // One start-point and one point at the mouse-position

        this.set = new SVG.Set();

        var p = this.startPoint,
          arr = [
            [p.x, p.y],
            [p.x, p.y],
          ];

        this.el.plot(arr);
      },

      // The calc-function sets the position of the last point to the mouse-position (with offset ofc)
      calc: function (e) {
        var arr = this.el.array().valueOf();
        arr.pop();

        if (e) {
          var p = this.transformPoint(e.clientX, e.clientY);
          arr.push(this.snapToGrid([p.x, p.y]));
        }

        this.el.plot(arr);
      },

      point: function (e) {
        if (this.el.type.indexOf("poly") > -1) {
          // Add the new Point to the point-array
          var p = this.transformPoint(e.clientX, e.clientY),
            arr = this.el.array().valueOf();

          arr.push(this.snapToGrid([p.x, p.y]));

          this.el.plot(arr);

          // Fire the `drawpoint`-event, which holds the coords of the new Point
          this.el.fire("drawpoint", {
            event: e,
            p: { x: p.x, y: p.y },
            m: this.m,
          });

          return;
        }

        // We are done, if the element is no polyline or polygon
        this.stop(e);
      },

      clean: function () {
        // Remove all circles
        this.set.each(function () {
          this.remove();
        });

        this.set.clear();

        delete this.set;
      },
    });

    // 创建撤销栈
    this.stack = new Undo.Stack();
    this.editCommand = Undo.Command.extend({
      constructor: function (type, data, fn) {
        this.type = type;
        this.data = data;
        this.fn = fn;
      },
      execute: function () {},
      undo: function () {
        this.fn("_undo", this.type, this.data);
      },
      redo: function () {
        this.fn("_redo", this.type, this.data);
      },
    });
  },
  methods: {
    initPainCanvas() {
      // 初始化绘画界面
      this.drawpath = SVG("drawing");
      this.drawpath.viewbox(
        0,
        0,
        this.TOOL.clientWidth,
        this.TOOL.clientHeight
      );

      const getDrawObject = () => {
        const option = {
          stroke: this.penColor || "#000000",
          "stroke-width": this.penWidth || 2,
          "stroke-linecap": "round",
          "fill-opacity": 0,
        };

        return this.drawpath.polyline().attr(option);
      };

      this.drawpath.on("mousedown", (event) => {
        const shape = getDrawObject();
        this.shapes[this.shapesIndex] = shape;
        shape.draw(event);
      });
      this.drawpath.on("mousemove", (event) => {
        if (this.shapes[this.shapesIndex]) {
          this.shapes[this.shapesIndex].draw("point", event);
        }
      });
      this.drawpath.on("mouseup", (event) => {
        this.shapes[this.shapesIndex].draw("stop", event);
        this.inStack({
          type: "paint",
          data: {
            index: this.shapesIndex,
            draw: this.shapes[this.shapesIndex],
          },
        });
        this.shapesIndex++;
      });

      return Promise.resolve(this.drawpath);
    },
    autodrawdata(data = 300) {
      // 获取绘画路径的相似图片
      this.timeAuto = setTimeout(() => {
        let autoHtml = "";
        if (this.shapes.length) {
          for (let svg of this.shapes) {
            autoHtml += svg.node.outerHTML;
          }
          let _svg = $("#drawing > svg")[0];
          let bbox = {};
          if (_svg) {
            bbox = _svg.getBBox();
          }
          if (!bbox.width) bbox.width = 60;
          if (!bbox.height) bbox.height = 60;
          let viewboxs =
            "" +
            (bbox.x - bbox.width * 0.2) +
            " " +
            (bbox.y - bbox.height * 0.2) +
            " " +
            bbox.width * 1.4 +
            " " +
            bbox.height * 1.4;
          let svghtml =
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' +
            viewboxs +
            '">' +
            autoHtml +
            "</svg>";
          this.$http
            .post("/api/autodraw", { svg: svghtml })
            .then((data) => {
              if (data.data.code === 200) {
                this.autoDraw.autodata = data.data.data;
                this.autoDraw.listLeft = 0;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.autoDraw.autodata = [];
        }
        clearTimeout(this.timeAuto);
      }, data);
    },
    clearTimeAuto() {
      // 鼠标按下，清除元素timeout事件
      if (this.timeAuto) {
        clearTimeout(this.timeAuto);
      }
    },
    autoSlide(data) {
      // 关于auto-draw-list的左右点击
      let listwidth = this.autoDraw.autodata.length * 60;
      let step = this.TOOL.clientWidth - 130;
      let action = step - listwidth;
      if (action < 0) {
        if (data === "next") {
          if (this.autoDraw.listLeft + step >= 0) {
            this.autoDraw.listLeft = 0;
          } else {
            this.autoDraw.listLeft += step;
          }
        } else if (data === "prever") {
          if (this.autoDraw.listLeft - step <= action) {
            this.autoDraw.listLeft = action;
          } else {
            this.autoDraw.listLeft -= step;
          }
        }
      }
    },
    generateData() {
      // 生成精灵数据
      let svgDom = null,
        bbox = null,
        viewBox = "",
        svgHtml = "",
        title = "我的绘画";

      if (this.drawStatus === "draw") {
        svgDom = SVG("drawSprite").size(
          this.TOOL.clientWidth,
          this.TOOL.clientHeight
        );
        for (let i of this.shapes) {
          i.fill("none").addTo(svgDom);
        }
        $("#drawSprite > svg > *").removeAttr("id");
        bbox = svgDom.bbox();
        viewBox =
          "" +
          (bbox.x - this.penWidth / 2) +
          " " +
          (bbox.y - this.penWidth / 2) +
          " " +
          (bbox.w + this.penWidth) +
          " " +
          (bbox.h + this.penWidth);
      } else if (this.drawStatus === "auto") {
        svgDom = this.rectDom.parent();
        this.rectDom.remove();
        svgDom.each(function (item) {
          this.attr("id", null);
        });
        title = this.svgTitle;
        viewBox = svgDom.attr("viewBox");
      }

      if (!svgDom) return;
      svgHtml = svgDom.node.innerHTML;
      svgHtml =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' +
        viewBox +
        '">' +
        svgHtml +
        "</svg>";
      this.$http
        .post("/api/user/autodraw", { title: title, svg: svgHtml })
        .then((res) => {
          if (res.data.code === 200) {
            this.closedraw();
            this.TOOL.addSprite(
              "Svg",
              {
                trackingType: "1010",
                url: res.data.data.filename,
                fileType: 19,
              },
              null,
              false
            ).then((s) => {
              this.closedraw();
              if (bbox) {
                s.update({
                  width: bbox.width,
                  height: bbox.height,
                  positionTop: bbox.y,
                  positionLeft: bbox.x,
                });
              }
              // s.update并不会记录到undo中，所以只能重新写undo
              let data = s.toJson(true);
              data.scenesId = s.scenesId;
              data.scale = this.TOOL.scale;
              eve("undo_redo", null, { type: "addSprite", data: data });
              this.$bus.emit("modifyUserItem_del_vue", { type: "pic" });
            });
          }
        });
    },
    drawComplete() {
      // if (!this.UserEquity.autoDraw) {
      //   this.$memberGuide({
      //     show: true,
      //     funcRight: {
      //       type: "AIDrawing",
      //       name: "AI绘图",
      //     },
      //   });
      //   return;
      // }
      // 绘画完成
      if (this.shapes.length) {
        this.generateData();
      } else {
        this.closedraw();
      }
    },
    addAutoSvg(data) {
      if (!this.UserEquity.autoDraw) {
        // this.$memberGuide({
        //   show: true,
        //   context: this,
        //   funcRight: {
        //     type: "AIDrawing",
        //     name: "AI绘图",
        //   },
        // });
        // return;
      }
      this.drawStatus = "auto";
      this.$fetch(data)
        .then((res) => {
          this.svgTitle = res.url.split("/").pop().split(".")[0];
          return res.text();
        })
        .then((txt) => {
          this.svgTxt2Dom(txt, true);
          this.openSet();
        });
    },
    svgTxt2Dom(txt, undo) {
      // 通过svg字符串成才dom
      let _this = this;
      $("#autodraw").html(txt).children().attr("id", "autodraw-svg");
      let draw = SVG("autodraw-svg");
      let classObj = {};
      let styleTag = draw.select("style");
      if (styleTag.members[0])
        classObj = this._getStyleObj(styleTag.members[0].node.innerHTML);
      styleTag.remove();
      draw.attr("id", null);
      // 去掉id
      draw.select("*").each(function () {
        let classname = this.attr("class");
        let style = this.style() || "";
        if (this.type === "style" || this.type === "defs") {
          this.remove();
          return;
        }
        let pathData = _this.convertPath(this, this.type);
        let node = this;
        if (pathData) node = pathData;
        if (classname) {
          var cls = classname.split(" ");
          cls.forEach((c) => {
            var cobj = classObj[c.trim()];
            if (cobj) {
              node.attr("style", style ? style + ";" + cobj : cobj);
            }
          });
        }
        this.attr({ id: null, class: null });
      });
      this.pathList = draw.select("path").members;
      this.syncPathInfo();
      undo &&
        this.inStack({
          type: "addAutoSvg",
          data: {
            title: this.svgTitle,
            html: draw.node.innerHTML,
            viewBox: draw.attr("viewBox"),
          },
        });
      this.rectDom = draw.rect(100, 100).opacity(0).attr({
        fill: "none",
        stroke: "#5778FB",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": 3,
        "stroke-dasharray": "6,6",
      });
    },
    _getStyleObj(str) {
      // 将style标签内的字符串转换为对象
      var arr = str ? str.match(/[\S\s]+?\}/g) : [],
        classobj = {};
      arr.forEach(function (a) {
        var split = a.split("{");
        var sname = split[0].trim(),
          content = split[1].split("}")[0].replace(/\n/g, "").trim();

        // 有逗号分隔的情况
        if (sname.indexOf(",") !== -1) {
          var c = sname.split(",");
          c.forEach(function (i) {
            i = i.trim();
            var attr = i.substr(1);
            if (i[0] === ".") {
              classobj[attr] = classobj[attr]
                ? (classobj[attr] += ";" + content)
                : content;
            }
          });
        } else {
          // class obj
          var attr = sname.substr(1);
          if (sname[0] === ".") {
            classobj[attr] = classobj[attr]
              ? (classobj[attr] += ";" + content)
              : content;
          }
        }
      });
      return classobj;
    },
    convertPath(e, type) {
      // 去掉特殊的svg元素
      let node = null,
        s = "";
      switch (type) {
        case "ellipse":
          let cx = e.attr("cx"),
            rx = e.attr("rx");
          s = SVG.format(
            "M{cxrx},{cy}a{rx},{ry} 0 1,0 {rx2},0a{rx},{ry} 0 1,0 -{rx2},0",
            {
              cxrx: cx - rx,
              rx2: rx * 2,
              cx: cx,
              cy: e.attr("cy"),
              rx: rx,
              ry: e.attr("ry"),
            }
          );
          node = e.replace(e.parent().path(s));
          break;
        case "circle":
          let r = e.attr("r");
          s = SVG.format(
            "M{cx} {cy}m-{r},0a{r},{r} 0 1,0 {r2},0a{r},{r} 0 1,0 -{r2},0",
            {
              cx: e.attr("cx"),
              cy: e.attr("cy"),
              r: r,
              r2: r * 2,
            }
          );
          node = e.replace(e.parent().path(s));
          break;
        case "polyline":
        case "polygon":
          let points = {
            type: type,
            points: e.attr("points").trim(),
          };
          s = SVGPoints.toPath(points);
          s = SVG.format(s);
          node = e.replace(e.parent().path(s));
          break;
        case "rect":
          let shape = {
            type: "rect",
            height: 20,
            width: 50,
            x: 10,
            y: 10,
            rx: 2,
            ry: 2,
          };
          $.each(shape, function (k, v) {
            if (k === "type") return;
            shape[k] = e.attr(k);
          });
          s = SVGPoints.toPath(shape);
          s = SVG.format(s);
          node = e.replace(e.parent().path(s));
          break;
        case "line":
          s = SVG.format("M{x1},{y1}L{x2},{y2}", {
            x1: e.attr("x1") || 0,
            y1: e.attr("y1") || 0,
            x2: e.attr("x2") || 0,
            y2: e.attr("y2") || 0,
          });
          node = e.replace(e.parent().path(s));
          break;
      }
      return node;
    },
    changePath(info, i) {
      // 切换path对应的变化
      let b = this.pathList[i].bbox();
      this.index = i;
      this.strokeWidth = +info["stroke-width"];
      this.everyColor = info.fill;
      this.strokeColor = info.stroke;
      this.rectDom
        .size(b.w + this.strokeWidth, b.h + this.strokeWidth)
        .move(b.x - this.strokeWidth / 2, b.y - this.strokeWidth / 2)
        .opacity(1);
    },
    showColorPicker({ whichPart } = {}) {
      this.$bus.emit("FeaturesPop_vue", {
        name: "color",
        posx: 100,
        posy: 130,
        type: 1,
        draw: true,
        whichPart,
        color: this.foreColor || "#ffffff",
      });
    },
    colorPickerInput(obj, { type }) {
      if (this.drawStatus === "auto") {
        if (type === "penColor") {
          let undoData = $.extend(true, [], this.pathInfo);
          this.pathList.forEach((v, i) => {
            v.style("stroke", obj.hex);
            this.pathInfo[i].stroke = obj.hex;
          });
          this.inStack({
            type: "strokeAll",
            data: {
              undoData: undoData,
              data: $.extend(true, [], this.pathInfo),
            },
          });
          return;
        }
        this.pathList[this.index].style(type, obj.hex);
        this.pathInfo[this.index][type] = obj.hex;
        if (type === "fill") {
          this.everyColor = obj.hex;
        } else {
          this.strokeColor = obj.hex;
        }
      } else if (this.drawStatus === "draw") {
        if (type === "penColor") {
          this.penColor = obj.hex;
        }
      }
    },
    dragDown(pos) {
      // 配色弹窗的拖动
      this.setDrag.x = pos.x - this.setDrag.left;
      this.setDrag.y = pos.y - this.setDrag.top;
      this.setDrag.move = true;
    },
    dragMove(pos) {
      this.setDrag.top = pos.y - this.setDrag.y;
      this.setDrag.left = pos.x - this.setDrag.x;
    },
    dragUp(pos) {
      this.setDrag.move = false;
    },
    openSet() {
      // 弹开配色弹窗
      this.showPathSet = true;
      if (this.index < 0) {
        this.changePath(this.pathInfo[0], 0);
      } else {
        this.rectDom.opacity(1);
      }
      this.pathInfoC = $.extend(true, [], this.pathInfo);
    },
    syncPathInfo() {
      // 同步path属性
      for (let i in this.pathList) {
        this.pathInfo[i] = {
          "stroke-width": this.pathList[i].style("stroke-width"),
          fill: this.pathList[i].style("fill"),
          stroke: this.pathList[i].style("stroke"),
        };
      }
    },
    certain(bol) {
      // 确认修改（取消）
      if (bol) {
        let undoData = $.extend(true, [], this.pathInfoC);
        this.inStack({
          type: "changePath",
          data: { undoData: undoData, data: $.extend(true, [], this.pathInfo) },
        });
      } else {
        this.pathInfoC.forEach((v, i) => {
          this.pathList[i].style(v);
          this.pathInfo[i] = this.pathInfoC[i];
        });
      }
      this.pathInfoC = [];
      this.showPathSet = false;
      this.rectDom.opacity(0);
    },
    changePenW(val) {
      if (this.drawStatus === "auto") {
        let undoData = $.extend(true, [], this.pathInfo);
        this.syncPathInfo();
        this.inStack({
          type: "changePenW",
          data: { undoData: undoData, data: $.extend(true, [], this.pathInfo) },
        });
      }
    },
    inputPenW(val) {
      if (this.drawStatus === "auto") {
        this.pathList.forEach((v) => {
          v.style("stroke-width", val);
        });
      }
    },
    inputStrokeW(val) {
      if (this.index > -1) {
        this.pathList[this.index].style("stroke-width", val);
        this.pathInfo[this.index]["stroke-width"] = val;
      }
    },
    backToDraw(undo) {
      // 重新绘画
      if (undo) {
        let draw = this.rectDom.parent();
        this.rectDom.remove();
        this.inStack({
          type: "backToDraw",
          data: {
            title: this.svgTitle,
            html: draw.node.innerHTML,
            viewBox: draw.attr("viewBox"),
          },
        });
      }
      this.drawStatus = "draw";
      this.initAutoDraw();
    },
    initAutoDraw() {
      this.pathList = [];
      this.pathInfo = [];
      this.index = -1;
      this.rectDom = null;
      $("#autodraw").empty();
    },
    smoothControlPoints(g, d, p) {
      // 优化曲线1
      var w = g.x - p.x,
        C = g.y - p.y,
        v = d.x - p.x,
        L = d.y - p.y;
      if ((w != 0 || C != 0) && (v != 0 || L != 0)) {
        g = Math.atan2(C, w);
        d = Math.atan2(L, v);
        w = Math.sqrt(w * w + C * C);
        v = Math.sqrt(v * v + L * L);
        C = { x: 0, y: 0 };
        L = { x: 0, y: 0 };
        if (g < 0) {
          g += 2 * Math.PI;
        }
        if (d < 0) {
          d += 2 * Math.PI;
        }
        var Q = Math.abs(g - d),
          J = Math.abs(Math.PI - Q) / 2;
        if (g - d > 0) {
          g = Q < Math.PI ? g + J : g - J;
          d = Q < Math.PI ? d - J : d + J;
        } else {
          g = Q < Math.PI ? g - J : g + J;
          d = Q < Math.PI ? d + J : d - J;
        }
        C.x = w * Math.cos(g) + p.x;
        C.y = w * Math.sin(g) + p.y;
        L.x = v * Math.cos(d) + p.x;
        L.y = v * Math.sin(d) + p.y;
        return [C, L];
      }
    },
    smoothPolylineIntoPath(D) {
      // 优化曲线2
      var z = D,
        F = D.length;
      if (F >= 6) {
        var k = z[0],
          n = null;
        D = [];
        D.push(["M", k.x, ",", k.y, " C"].join(""));
        for (var q = 1; q <= F - 4; q += 3) {
          var u = z[q],
            E = z[q + 1],
            I = z[q + 2];
          if (n) {
            if ((k = this.smoothControlPoints(n, u, k)) && k.length == 2) {
              u = D[D.length - 1].split(",");
              u[2] = k[0].x;
              u[3] = k[0].y;
              D[D.length - 1] = u.join(",");
              u = k[1];
            }
          }
          D.push([u.x, u.y, E.x, E.y, I.x, I.y].join(","));
          k = I;
          n = E;
        }
        for (D.push("L"); q < F; ++q) {
          E = z[q];
          D.push([E.x, E.y].join(","));
        }
        D = D.join(" ");
      }
      return D;
    },
    leavingDraw() {
      // 离开draw提示
      if (this.shapes.length) {
        this.$bus.emit("FeaturesPop_vue", {
          actionType: "autoDraw",
          name: "vipPayment",
          msg: "是否保存当前绘画？",
          btnClose: "直接退出", // 左侧按钮信息
          btnMsg: "保存并退出", // 右侧按钮信息
          fs: "draw",
          msgType: 2, // 0--左链接，右按钮；1--双链接；2--双按钮
          type: 2,
        });
      } else {
        this.$bus.emit("FeaturesPop_vue", {
          actionType: "autoDraw",
          name: "vipPayment",
          msg: "是否退出当前绘画？",
          btnClose: "直接退出", // 左侧按钮信息
          fs: "draw",
          msgType: 2, // 0--左链接，右按钮；1--双链接；2--双按钮
          type: 2,
        });
      }
    },
    closedrawFs() {
      // 关闭autodraw函数
      if (this.shapes.length) {
        this.$bus.emit("FeaturesPop_vue", {
          actionType: "autoDraw",
          name: "vipPayment",
          msg: "是否保存当前绘画？",
          btnClose: "直接退出", // 左侧按钮信息
          btnMsg: "保存并退出", // 右侧按钮信息
          fs: "draw",
          msgType: 2, // 0--左链接，右按钮；1--双链接；2--双按钮
          type: 2,
        });
      } else {
        this.closedraw();
      }
    },
    closedraw(event) {
      // 关闭绘画
      this.isShow = false;
      this.$store.commit("toggle_isPreventDefault", true);
      this.drawStatus = "draw";
      this.autoDraw.autodata = []; // 清空残留数据
      this.autoDraw.autoAction = true;
      this.initAutoDraw();
      $("#drawing").empty();
      $("#drawSprite").empty();
      this.$bus.emit("drawing_vue", { type: "tool" });
    },
    fn(mod, type, data) {
      this[mod](type, data);
    },
    inStack(data) {
      // 画布栈入栈
      this.stack.execute(new this.editCommand(data.type, data.data, this.fn));
      this.canUndoRedo();
    },
    undo() {
      this.stack.undo();
      this.canUndoRedo();
    },
    redo() {
      this.stack.redo();
      this.canUndoRedo();
    },
    _undo(type, data) {
      let svgHtml = "";
      switch (type) {
        case "paint":
          data.draw.remove();
          this.shapes.splice(data.index, 1);
          this.shapesIndex = data.index;
          this.autodrawdata(300);
          break;
        case "addAutoSvg":
          this.backToDraw();
          break;
        case "changePenW":
        case "strokeAll":
        case "changePath":
          data.undoData.forEach((v, i) => {
            this.pathList[i].style(v);
            this.pathInfo[i] = Object.assign({}, v);
          });
          break;
        case "backToDraw":
          this.title = data.title;
          this.drawStatus = "auto";
          svgHtml =
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' +
            data.viewBox +
            '">' +
            data.html +
            "</svg>";
          this.svgTxt2Dom(svgHtml);
          break;
        default:
          break;
      }
    },
    _redo(type, data) {
      let svgHtml = "";
      switch (type) {
        case "paint":
          this.shapes.splice(data.index, 0, data.draw);
          data.draw.addTo(this.drawpath);
          this.shapesIndex = data.index + 1;
          this.autodrawdata(300);
          break;
        case "addAutoSvg":
          this.title = data.title;
          this.drawStatus = "auto";
          svgHtml =
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' +
            data.viewBox +
            '">' +
            data.html +
            "</svg>";
          this.svgTxt2Dom(svgHtml);
          break;
        case "changePenW":
        case "strokeAll":
        case "changePath":
          data.data.forEach((v, i) => {
            this.pathList[i].style(v);
            this.pathInfo[i] = Object.assign({}, v);
          });
          break;
        case "backToDraw":
          this.backToDraw();
          break;
        default:
          break;
      }
    },
    canUndoRedo() {
      this.canUndo = this.stack.canUndo();
      this.canRedo = this.stack.canRedo();
    },
  },
  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.draw {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 12;
  width: 100%;
  height: 100%;
}

.draw-body {
  position: absolute;
  top: 62px;
}

.draw-suggest {
  position: absolute;
  top: -122px;
  left: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  overflow: hidden;
  height: 80px;

  > div {
    position: relative;
    z-index: 0;
    overflow: hidden;
    width: 100%;
    height: 60px;
    padding: 5px 0;
    border-radius: 3px;
  }

  .open-auto-draw {
    width: 215px;
    height: 100%;
    padding: 0 10px;
    margin: 0 auto;
    color: #8a8a8e;
    font-size: 18px;
    font-weight: 700;
    line-height: 3;
    background: #fff;
    border-radius: 15px;
    cursor: pointer;

    span {
      font-size: 30px;
      vertical-align: sub;
    }
  }

  .auto-draw-btn {
    position: absolute;
    top: 0;
    width: 60px;
    height: 60px;
    color: #a09e9e;
    font-size: 35px;
    font-weight: 900;
    line-height: 60px;
    background-color: rgb(231, 231, 238);
    cursor: pointer;
  }

  .auto-draw-box {
    position: absolute;
    top: 0;
    left: 100px;
    overflow: hidden;
    height: 60px;
    background: rgb(231, 231, 238);

    .auto-draw-list {
      position: absolute;
      top: 5px;
      left: 0;
      display: flex;
      transition: all 0.4s;
    }

    .auto-draw-svg {
      width: 50px;
      height: 50px;
      margin-left: 10px;
      background: #fff;

      div {
        width: 50px;
        height: 50px;
        background-color: #fff;
        transition: all 0.3s;
        cursor: pointer;

        &:hover {
          background: rgba(221, 221, 221, 1);
        }
      }
      img {
        height: 100%;
        vertical-align: middle;
        user-select: text;
      }
    }
  }

  .el-icon-arrow-right {
    right: 0;
    width: 30px;
  }
  .el-icon-arrow-left {
    left: 70px;
    width: 30px;
  }
  .el-icon-caret-bottom {
    left: 0;
  }
}

.btn-content {
  position: absolute;
  top: -37px;
  right: 0;
  left: 0;
  height: 34px;
  margin: 0 auto;

  .left-box,
  .right-box {
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    height: 100%;
  }

  .left-box {
    top: -3px;
    left: 0;
    justify-content: end;
    height: 40px;
    padding: 2px 0 2px 2px;
    background-color: #e8eaf4;

    .left-btn {
      width: 44px;
      height: 34px;
      margin-right: 3px;
      line-height: 34px;
      background-color: #fafaff;
      border-radius: 4px;
      cursor: pointer;

      span {
        display: block;
        width: 26px;
        height: 22px;
        margin: 6px auto;
        background-color: #5778fb;
        border-radius: 4px;
      }

      &:not(.disabled):hover {
        background-color: rgb(150, 146, 169);

        .icon-editor-undo {
          background: url("../../static/svg/undo-active.svg") no-repeat;
        }
        .icon-editor-redo {
          background: url("../../static/svg/redo-active.svg") no-repeat;
        }
      }

      &.disabled {
        cursor: not-allowed;
      }
    }

    .path-set-btn {
      width: 60px;
      font-size: 13px;

      .icon-draw-match {
        position: relative;
        top: 3px;
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url("../../static/svg/match.svg") no-repeat;
      }

      &:hover {
        color: #fff;
        .icon-draw-match {
          background: url("../../static/svg/match-active.svg") no-repeat;
        }
      }
    }

    .dragfix {
      width: 180px;
    }
  }

  .right-box {
    right: 0;
    justify-content: flex-end;
    width: 215px;

    > div {
      height: 34px;
      padding: 0 10px;
      margin-left: 5px;
      line-height: 34px;
      background: #fff;
      border-radius: 4px;
      cursor: pointer;

      &:first-child {
        color: #fff;
        background-color: #5778fb;
      }
    }
  }
}

.drawing {
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  > img {
    width: 100%;
    height: 100%;
  }
  #autodraw,
  #drawing {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.draw-vip {
  position: absolute;
  top: -109px;
  right: -24px;
  z-index: 10;
  width: 50px;
  height: 14px;
  background-image: url(../../static/svg/payTypeSubscript/vip36x14.svg);
  background-repeat: no-repeat;
  background-size: auto 100%;
  cursor: pointer;
}

.color-setting {
  position: absolute;
  top: 10px;
  left: -100px;
  overflow: hidden;
  width: 184px;
  height: 360px;
  color: #474261;
  font-size: 13px;
  background: #fff;
  box-shadow: 0 0 3px 1px #d8dee9;
  border-radius: 8px;

  &-title {
    width: 100%;
    height: 30px;
    padding: 5px 15px;
    font-size: 15px;
    line-height: 20px;
    text-align: left;
    background: #d8dee9;
    cursor: move;
  }

  &-fill,
  &-stroke {
    display: flex;
    height: 30px;
    padding: 2px 15px;

    > div {
      width: 27px;
      height: 16px;
      margin-left: 10px;
      border: 1px solid #d9ddea;
    }

    p {
      width: 70px;
      margin-left: 20px;
    }
  }
  &-fill {
    margin-top: 10px;
  }

  &-select {
    padding: 2px 15px;
    text-align: left;
  }

  .path-content {
    width: 100%;
    height: 170px;
  }

  .bar-content {
    display: flex;
    flex-wrap: wrap;
    padding: 5px 9px;

    div {
      box-sizing: border-box;
      width: 35px;
      height: 23px;
      margin: 3px;
      background-color: #fff;
      border: 1px solid #d9ddea;
      border-radius: 4px;
      cursor: pointer;
    }

    .active {
      border: 1px solid #5778fb;
    }
  }

  &-footer {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 60px;
    padding: 18px 15px;

    div {
      width: 72px;
      height: 32px;
      font-size: 14px;
      line-height: 30px;
      background-color: #f4f4f8;
      border: 1px solid #d9ddea;
      border-radius: 5px;
      cursor: pointer;

      &:first-child {
        color: #fff;
        background-color: #5778fb;
        border-color: #5778fb;
      }
    }
  }
}

// 动画部分
.path-rect {
  position: absolute;
  background: #1593ff77;
}

.slide-fade-leave-active,
.slide-fade-enter-active {
  transition: all 0.3s linear;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-68px);
  opacity: 0;
}

.slide-list-enter,
.slide-list-leave-to {
  transform: translateY(50px);
  opacity: 0;
}
.slide-list-enter-active,
.slide-liston-enter-active,
.slide-list-leave-active,
.slide-liston-leave-active {
  transition: all 0.3s linear;
}
.slide-liston-enter,
.slide-liston-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
</style>
<style lang="scss">
#autodraw svg {
  width: auto;
  height: 100%;
}
.dragfix {
  width: 182px;
  margin: 0 10px;
  position: relative;

  .el-slider__bar {
    background-color: #8b8c8c;
  }
  .el-slider__button {
    border: 2px solid #eff1f8;
    background-color: #777575;
  }
  .el-slider__runway {
    height: 4px;
    background-color: #ffffff;
  }
  .el-slider__bar {
    height: 4px;
  }
  .el-slider__button-wrapper {
    height: 33px;
    width: 33px;
  }
}
.stroke-set-slider {
  margin-top: -2px;
  .el-slider__runway {
    height: 4px;
    margin: 8px 0;
    border-radius: 0;
  }
  .el-slider__bar {
    height: 4px;
    border-radius: 0;
  }
  .el-slider__button-wrapper {
    height: 33px;
    width: 33px;
  }
  .el-slider__button {
    width: 10px;
    height: 10px;
    background-color: #5778fb;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Draw.vue